import { render } from "./SelectInputFilter.vue?vue&type=template&id=19d24d96"
import script from "./SelectInputFilter.vue?vue&type=script&lang=js"
export * from "./SelectInputFilter.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/sbimh.nl/tickets.sbimh.nl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__